// extracted by mini-css-extract-plugin
export default {"frameWrap":"LogIn_frameWrap__dfUcg","inputWrap":"LogIn_inputWrap__B4yF9","logoWrap":"LogIn_logoWrap__FBsdR"};